export default __webpack_public_path__ + "static/media/home-gray.4981ed36.svg";